import { apiFetch } from "@/lib/api";

/** The Django API wraps list bodies as `{ success, message, data, meta }`. */
interface Envelope<T> {
  data: T;
  meta?: { count: number; next: string | null; previous: string | null };
}

/** A Business-Practitioner firm row in the GA/SA directory. */
export interface BusinessPractitioner {
  id: string;
  name: string;
  /** Short identifier / sub-name shown next to this BP's team members. */
  code: string;
  email: string;
  org_type: "house" | "business_practitioner";
  member_count: number;
  created_at: string;
}

export interface CreateBusinessPractitionerPayload {
  name: string;
  /** Short identifier / sub-name (e.g. "MVB"). */
  code?: string;
  admin_name?: string;
  admin_email: string;
  admin_is_practitioner?: boolean;
  /** House Country Directors to assign this BP to on creation (their portfolio). */
  country_director_ids?: number[];
}

/** GET /firm/business-practitioners — the BP directory (GA/SA only). */
export async function listBusinessPractitioners(): Promise<BusinessPractitioner[]> {
  const body = await apiFetch<Envelope<BusinessPractitioner[]>>(
    "/firm/business-practitioners?page_size=100",
  );
  return body.data;
}

/** POST /firm/business-practitioners — provision a BP firm + invite its first
 * Country Director. Returns the created BP row. */
export async function createBusinessPractitioner(
  payload: CreateBusinessPractitionerPayload,
): Promise<BusinessPractitioner> {
  const body = await apiFetch<Envelope<BusinessPractitioner>>("/firm/business-practitioners", {
    method: "POST",
    json: payload,
  });
  return body.data;
}
